import axios from "axios";
import { useState } from "react";

const useNoReplySelf = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
    onFinishFile = ({ axiosMode, status, values }) => { },
}) => {
    const [data, setData] = useState([])
    const [roleData, setRoleData] = useState([])
    const mainApi = '/app/no_reply_self'
    const getNoReplySelfData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data.data
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data,
                }
            });
    }
    const postNoReplySelfData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                console.log(responseData)
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error",
                            values: responseData

                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success",
                            values: responseData
                        }
                    )
                    
                    // 判斷是否需要發送通知
                    if (responseData.no_reply_autoreply_data === null) {
                        // 執行館員通知的相關邏輯，這裡可能涉及調用後端進行通知處理
                        sendStaffNotifications();
                    }
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    // 發送館員通知的邏輯（假設有一個函數來處理通知）
    const sendStaffNotifications = () => {
        // console.log('我是測試人員')
        axios.get('/app/no_reply/notification_to_staff')
            .then((response) => {
                console.log('通知已發送', response.data);
            })
            .catch((error) => {
                console.error('通知發送失敗', error);
            });
    }
    const patchNoReplySelfData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "failure") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deletehNoReplySelfData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        noReplySelfData: data,
        getNoReplySelfData,
        postNoReplySelfData,
        // patchNoReplySelfData,
        // deletehNoReplySelfData,
    }
}
export { useNoReplySelf }